import { render, staticRenderFns } from "./UserDetailModal.vue?vue&type=template&id=faf5633e&"
import script from "./UserDetailModal.vue?vue&type=script&lang=js&"
export * from "./UserDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailModal.vue?vue&type=style&index=0&id=faf5633e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCheckbox,VChip,VIcon,VRow,VSpacer,VSwitch})
